import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { debounceTime, switchMap, tap, filter } from "rxjs/operators";
import { MatOptionSelectionChange } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { GenericComponent } from "../../components/generic.component";
import {
  ServiceDTO,
  ServiceFindByFiltersDTO
} from "@shared/models/service-dto";
import { ServiceBoschService } from "@core/services/service-bosch.service";
import { BudgetServiceItemFormModalComponent } from "../budget-service-item-form-modal/budget-service-item-form-modal.component";
import { PageManager } from "@shared/models/page-manager";
import { DEFAULT_PAGINATION } from "@shared/constants/default-pagination";
import { Pagination } from "@shared/models/pagination";
import { ServiceRequestDetailsClientDTO } from "@shared/models/service-request-details-client-dto";
import { ServiceRequestDetailsVehicleDTO } from "@shared/models/service-request-details-vehicle-dto";

@Component({
  selector: "app-smartfleet-service-auto-complete",
  templateUrl: "./service-auto-complete.component.html",
  styleUrls: ["./service-auto-complete.component.scss"],
  standalone: false
})
export class ServiceAutoCompleteComponent
  extends GenericComponent
  implements OnInit
{
  loading = false;
  service = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.service
  });

  services: ServiceDTO[] = [];

  pageManager: PageManager = {
    totalElements: 0,
    pageIndex: DEFAULT_PAGINATION.PAGE_INDEX,
    pageSize: DEFAULT_PAGINATION.PAGE_SIZE
  };

  @Input() title = "";
  @Input() requiredText = "";
  @Input() context = "";
  @Input() isBoschClient = false;
  @Input() required = false;
  @Input() client?: ServiceRequestDetailsClientDTO;
  @Input() vehicle?: ServiceRequestDetailsVehicleDTO;
  @Input() fee?: boolean;
  @Input() set disabled(value: boolean) {
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  @Output() onChange: any = new EventEmitter<ServiceDTO>();

  constructor(
    injector: Injector,
    private serviceBoschService: ServiceBoschService,
    private loadingDrivebService: LoadingDrivebService,
    private dialog: MatDialog
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.service.valueChanges
      .pipe(
        debounceTime(400),
        filter((value) => {
          if (value) {
            return value;
          }
        }),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const searchForm = {} as ServiceFindByFiltersDTO;
            searchForm.nameFilter = value;
            if (this.client?.id) {
              searchForm.clientId = this.client.id;
            }

            if (this.fee) {
              if (this.vehicle?.id) {
                searchForm.vehicleId = this.vehicle.id;
              }

              searchForm.fee = this.fee;
            }

            return this.serviceBoschService.findByFilters(
              searchForm,
              this.pageManager
            );
          } else {
            this.onChange.emit({} as ServiceDTO);
            return new Observable<Pagination<ServiceDTO[]>>();
          }
        })
      )
      .subscribe((data) => {
        this.services = data.content;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      });
  }

  handleServiceChange(
    event: MatOptionSelectionChange,
    service: ServiceDTO
  ): void {
    if (event.isUserInput === true) {
      this.onChange.emit(service);
    }
  }

  addNewService() {
    this.dialog
      .open(BudgetServiceItemFormModalComponent, {
        width: "900px",
        data: {
          isBoschClient: this.isBoschClient,
          isFee: this.fee
        }
      })
      .afterClosed()
      .subscribe((data) => {
        if (data) {
          this.searchForm.patchValue({
            name: data.serviceName
          });
          this.onChange.emit(data);
        }
      });
  }

  clean(): void {
    this.searchForm.reset();
  }

  setValue(value: string): void {
    this.searchForm
      .get("name")
      .setValue(value, { emitEvent: false, onlySelf: true });
  }
}
